import { useState } from 'react';
import { MonitorDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Modal } from '@/components/ui/system';
import { INSTALL_STEPS, installGuide, runningAsApp, useInstallPrompt } from '@/lib/install-app';

/** Install steps for browsers that don't offer their own prompt. */
export function InstallAppDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const steps = INSTALL_STEPS[installGuide(navigator.userAgent, navigator.maxTouchPoints)];
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Install CallSync"
      description="Open your dashboard from the dock, taskbar or home screen, in its own window."
      footer={<Button onClick={onClose}>Done</Button>}
    >
      {steps.length === 1 ? (
        <p className="text-sm">{steps[0]}</p>
      ) : (
        <ol className="list-decimal space-y-2 pl-5 text-sm">
          {steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      )}
    </Modal>
  );
}

/**
 * Optional install offer: the browser's prompt where there is one, otherwise the steps.
 * Hidden inside the installed app and when the app is already on this device.
 */
export function InstallAppButton() {
  const prompt = useInstallPrompt();
  const [help, setHelp] = useState(false);
  if (runningAsApp() || prompt.installed) return null;
  return (
    <>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => (prompt.ready ? void prompt.open() : setHelp(true))}
      >
        <MonitorDown />
        Install the dashboard as an app
      </Button>
      <InstallAppDialog open={help} onClose={() => setHelp(false)} />
    </>
  );
}
